import React from 'react';
import Floating from "../../common/Floating";
import FadeSlideIn from "../../common/FadeSlideIn";
import moneyGunBanner from "../../../resources/rewardsBackdrop.png"
import howlLogo from "../../../resources/howlLogoBig.png"
import howlChipsBag from "../../../resources/chipsBag.png"
import howlChargeIcon from "../../../resources/chargeIcon.png"
import howlChest from "../../../resources/howlChest.png"


const LandingRewards = () => {
    return (<FadeSlideIn>
        <div className="container landingRewards">

            <div className="contentBox">
                <img src={moneyGunBanner} alt="" className="moneyGun"/>
                <div className="content">
                    <img src={howlLogo} alt="" className="howlLogo"/>
                    <h1>Premium Rewards</h1>
                    <p>Register today using code “Nick” and receive exclusive rewards instantly!</p>

                    <div className="allRewards">
                        <div className="reward">
                            <div className="rewardImage">
                                <img src={howlChipsBag} alt=""/>
                            </div>
                            <div className="rewardText">
                                <div className="rewardTextHeader">ANYTIME</div>
                                <div className="rewardTextSubtitle">DEPOSIT <br/>BONUS</div>
                            </div>
                        </div>
                        <div className="reward">
                            <div className="rewardImage">
                                <img src={howlChargeIcon} alt=""/>
                            </div>
                            <div className="rewardText">
                                <div className="rewardTextHeader">7-DAY</div>
                                <div className="rewardTextSubtitle">UP TO 25% <br/>RAKEBACK</div>
                            </div>
                        </div>
                        <div className="reward">
                            <div className="rewardImage">
                                <img src={howlChest} alt=""/>
                            </div>
                            <div className="rewardText">
                                <div className="rewardTextHeader">DAILY</div>
                                <div className="rewardTextSubtitle">FREE <br/>CASES</div>
                            </div>
                        </div>
                    </div>
                    <a href="#" className="btn btn-howl">CLAIM REWARDS</a>
                </div>
            </div>

        </div>
    </FadeSlideIn>);
}
export default LandingRewards;